/*****************************************************************
 ** Copyright (c) 帕加马直播预览
 ** 创建人:      Eugene
 ** 创建日期:    2020/10/10
 ** 修改人:
 ** 修改日期:
 ** 描 述: 全局只读配置
 **-----------------------------------------------------------------
 ******************************************************************/

import request from '@/utils/$x';

// 渠道列表
export async function getLiveChannelList(params) {
  return request.http('/livePlay/getLiveChannelList', {
    method: 'post',
    data: params,
  });
}

// 比例列表
export async function getLiveScreenRatio(params) {
  return request.http('/livePlay/getLiveScreenRatio', {
    method: 'post',
    data: params,
  });
}

// 新增渠道
export async function addLiveChannel(params) {
  return request.http('/livePlay/addLiveChannel', {
    method: 'post',
    data: params,
  });
}

// 删除渠道
export async function deleteLiveChannel(params) {
  return request.http('/livePlay/deleteLiveChannel', {
    method: 'post',
    data: params,
  });
}

// 编辑渠道
export async function editLiveChannel(params) {
  return request.http('/livePlay/editLiveChannel', {
    method: 'post',
    data: params,
  });
}
